var _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-37"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.53,
    cy: 288.69,
    r: 95.44,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-37"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-37",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.54,184.13c-.16,2.77-.48,5.31-.84,8s-.86,5.2-1.43,7.78-1.19,5.17-2,7.72a71.69,71.69,0,0,1-2.77,7.57l-.84,1.87c-.12.28-.35.69-.53,1s-.39.68-.59,1a29,29,0,0,1-2.6,3.47,59.21,59.21,0,0,1-5.7,5.72,106.44,106.44,0,0,1-12.49,9.46l-2.54-3.28c1.79-1.73,3.61-3.52,5.37-5.3s3.5-3.6,5.15-5.44a71.15,71.15,0,0,0,4.61-5.6,25.54,25.54,0,0,0,1.78-2.81c.1-.22.23-.45.32-.66a7.23,7.23,0,0,0,.29-.69l.64-1.67a94.15,94.15,0,0,0,3.78-14.09c.48-2.41.83-4.86,1.19-7.3s.63-5,.85-7.28Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.84,174.16c-3.37.85-5.73,14.74-5.73,14.74l9.3,6.32s8.91-14,6.32-17.71C329,173.64,326.77,172.9,321.84,174.16Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.15 177.26 319.56 191.25 324.78 194.8 322.15 177.26",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.75,233.26l-9.28.67,5.54,6.21s5.13-1.17,6-4.45Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.35 237.22 286.15 243.07 293.01 240.14 287.47 233.93 282.35 237.22",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.1 407.88 331.91 407.88 331.37 388.92 339.55 388.92 340.1 407.88",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.72 383.75 389.14 386.84 379.54 370.29 387.12 367.19 396.72 383.75",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.71,385.71l7.91-4.7a.65.65,0,0,1,.85.15l4.62,5.72a1.32,1.32,0,0,1-.39,1.92c-2.78,1.59-4.21,2.22-7.69,4.28-2.14,1.27-7.17,5.63-10.12,7.39s-4.85-1.08-3.77-2.07a28.07,28.07,0,0,0,7.67-11.56A2.15,2.15,0,0,1,387.71,385.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.63,406.93h9.2a.63.63,0,0,1,.65.56l1,7.28a1.31,1.31,0,0,1-1.31,1.45c-3.21-.05-4.75-.24-8.8-.24-2.49,0-7.63.26-11.07.26s-3.62-3.4-2.19-3.71c6.42-1.38,8.94-3.28,11.1-5.1A2.18,2.18,0,0,1,331.63,406.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "331.37 388.92 331.65 398.7 339.84 398.7 339.56 388.92 331.37 388.92"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.12 367.19 379.54 370.29 384.49 378.82 392.07 375.73 387.12 367.19"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M321.84,174.16s-3.9,1.37,3.92,49.41H359c-.56-13.53-.58-21.88,5.89-49.65a97.21,97.21,0,0,0-14.12-1.86,105.58,105.58,0,0,0-15.1,0C329.2,172.65,321.84,174.16,321.84,174.16Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.78,172.06a105.58,105.58,0,0,0-15.1,0c-1.81.16-3.69.4-5.46.65h0c-.77,2.92-.62,7,2.36,12.34h0a4,4,0,0,0,5,1.75h0c2.42-1,14.67-6.15,18.61-12.53l1-1.65C355.21,172.38,353,172.17,350.78,172.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.9,143.72c0,12-9.88,19.92-20.35,24.93-10.83,5.18-21.73-9.73-21.73-21.73a21.73,21.73,0,0,1,21.73-21.74C356.55,125.18,364.9,131.72,364.9,143.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.66,129.85c0,4.55-3.16,9.45-7.72,9.45a8.24,8.24,0,0,1,0-16.48C364.5,122.82,367.66,125.3,367.66,129.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.29,155.06c-1,4.85-1.91,13.76,1.49,17,0,0-1.33,4.93-10.35,4.93-9.93,0-4.75-4.93-4.75-4.93,5.42-1.3,5.28-5.32,4.34-9.09Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.78,172.06a105.58,105.58,0,0,0-15.1,0l-1,.1a8.84,8.84,0,0,0-.44,6.7,4,4,0,0,0,5.59,2.56c4.18-2,10.66-5.57,12.92-9.23C352.11,172.14,351.44,172.09,350.78,172.06Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,158.29,340,163a15.86,15.86,0,0,1,.47,2.68c2.07-.3,4.91-2.57,5.13-4.74A7.4,7.4,0,0,0,345.51,158.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.08,142.46c1.51,8,2.32,11.33-.63,16.37-4.44,7.58-14.58,7.69-18.44.31-3.48-6.63-5.36-18.58,1.55-23.65A11.08,11.08,0,0,1,350.08,142.46Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.76,223.57s-6.46,63.07-5.92,88c.55,26,10.07,85.19,10.07,85.19H341s-1.75-57.71-.77-83.21c1.06-27.81,9.9-90,9.9-90Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.94 397.2 328.95 397.2 328 393.06 342.54 392.55 341.94 397.2",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.1,239.26c-8.17,16.43-1.64,46.4,1.25,57.55,1.48-16.74,4-37.22,5.92-52.25C346,236.06,343.87,231.69,340.1,239.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.54,223.57s7.53,65.57,13.22,86.62c6.75,25,34.19,67.63,34.19,67.63l10.33-4.22s-17.71-48.55-22.88-61.72c-11-28.1-1.58-70-10.39-88.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.69 373.65 380.87 378.89 377.86 375.41 392.67 368.58 393.69 373.65",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.07,147.72c.16.64-.05,1.24-.46,1.35s-.89-.33-1.06-1,.05-1.24.47-1.35S337.91,147.08,338.07,147.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.83,149.55c.17.64,0,1.25-.46,1.35s-.89-.33-1.05-1,0-1.24.46-1.35S330.67,148.91,330.83,149.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,148.57l-1.65,0S329.42,149.52,330,148.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.36,150.14a17.61,17.61,0,0,1-1.25,4.66,2.82,2.82,0,0,0,2.39-.15Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.63,156.28a7.8,7.8,0,0,1-.93.31.21.21,0,0,1-.24-.14.2.2,0,0,1,.14-.24,5.28,5.28,0,0,0,3.64-3,.19.19,0,1,1,.36.13A5.42,5.42,0,0,1,338.63,156.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.83,136.5s10.7,11,21.37,11c8.78,0,8.49-14.72-3.12-15.33S324.72,128.42,329.83,136.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.05,149.18a5.93,5.93,0,0,1-2.26,3.93c-1.66,1.26-3.25,0-3.43-2-.16-1.77.51-4.56,2.48-5A2.67,2.67,0,0,1,354.05,149.18Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.5,143.81a.38.38,0,0,1-.45.07c-1.59-.82-3.65.23-3.67.24a.38.38,0,1,1-.36-.68c.1-.06,2.44-1.25,4.39-.25a.38.38,0,0,1,.16.52A.36.36,0,0,1,339.5,143.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.08,145.47a.38.38,0,0,1-.38-.05.39.39,0,0,1-.09-.54,3.87,3.87,0,0,1,3.14-1.65.39.39,0,0,1,.36.41.38.38,0,0,1-.4.37,3.09,3.09,0,0,0-2.47,1.33A.4.4,0,0,1,327.08,145.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.57,388.81h-.1a1.12,1.12,0,0,1-.8-.72.65.65,0,0,1,.06-.67c.59-.86,3.55-.75,3.89-.73a.18.18,0,0,1,.17.12.18.18,0,0,1-.05.21C387,387.75,385.58,388.93,384.57,388.81Zm2.56-1.76c-1.18,0-2.77.13-3.09.58a.3.3,0,0,0,0,.3.74.74,0,0,0,.52.49C385.11,388.54,386.05,388,387.13,387.05Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.31,387.05c-1-.12-2.81-.81-3.09-1.61a.68.68,0,0,1,.28-.8,1.05,1.05,0,0,1,.84-.2c1.17.23,2.38,2.25,2.43,2.33a.2.2,0,0,1,0,.2.23.23,0,0,1-.17.1Zm-2.1-2.23a.62.62,0,0,0-.47.13c-.2.15-.19.27-.15.36.19.54,1.66,1.21,2.65,1.34-.44-.65-1.27-1.69-2-1.83Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.56,408.36a3.13,3.13,0,0,1-2-.5,1.11,1.11,0,0,1-.35-.95.62.62,0,0,1,.33-.51c1-.56,4.27,1.11,4.64,1.31a.19.19,0,0,1,.1.2.19.19,0,0,1-.15.16A13.91,13.91,0,0,1,328.56,408.36Zm-1.46-1.69a.74.74,0,0,0-.36.07.24.24,0,0,0-.13.21.72.72,0,0,0,.22.62c.5.45,1.85.52,3.66.22A10.43,10.43,0,0,0,327.1,406.67Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,408.07H331c-1-.45-2.91-2.21-2.76-3.14,0-.22.19-.49.73-.55a1.44,1.44,0,0,1,1.08.34c1,.86,1.21,3.06,1.22,3.15a.18.18,0,0,1-.08.18A.2.2,0,0,1,331.1,408.07Zm-2-3.32H329c-.35,0-.38.18-.38.22-.1.56,1.22,1.95,2.21,2.55a4.54,4.54,0,0,0-1-2.52A1,1,0,0,0,329.15,404.75Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.21,146.74l-1.65-.05S336.66,147.69,337.21,146.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51,221.62l.85,3c.11.24-.16.47-.55.47H325.59c-.3,0-.55-.15-.56-.33l-.3-3c0-.21.23-.38.56-.38H359A.62.62,0,0,1,359.51,221.62Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51,221.62l.85,3c.11.24-.16.47-.55.47H325.59c-.3,0-.55-.15-.56-.33l-.3-3c0-.21.23-.38.56-.38H359A.62.62,0,0,1,359.51,221.62Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,225.38h.91c.18,0,.31-.09.3-.2l-.42-3.87a.34.34,0,0,0-.35-.21h-.9c-.18,0-.32.1-.31.21l.42,3.87C354.65,225.29,354.8,225.38,355,225.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.13,225.38h.9c.18,0,.31-.09.3-.2l-.42-3.87c0-.11-.17-.21-.35-.21h-.9c-.18,0-.32.1-.31.21l.43,3.87C327.79,225.29,328,225.38,328.13,225.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.56,225.38h.9c.18,0,.31-.09.3-.2l-.42-3.87c0-.11-.17-.21-.35-.21h-.9c-.18,0-.32.1-.31.21l.43,3.87C341.22,225.29,341.38,225.38,341.56,225.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.47,223.25l-7.2-5.14.67,8.3s4.8,2.15,7.49.08Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.78,183.78c.62,4.89,1.15,9.8,1.64,14.71s.95,9.82,1.36,14.73l.07.92,0,.49c0,.26,0,.52,0,.78a8.59,8.59,0,0,1-.59,3.19,9.86,9.86,0,0,1-3.61,4.4,17.07,17.07,0,0,1-4.08,2.07,30.8,30.8,0,0,1-4,1.12,58.9,58.9,0,0,1-15.45.88l-.05-4.14c2.33-.31,4.75-.68,7.07-1.15A51.35,51.35,0,0,0,358,220a17.1,17.1,0,0,0,5.43-2.7,2.51,2.51,0,0,0,.94-1.3,1.27,1.27,0,0,0,0-.44l-.22-1.49c-.72-4.89-1.39-9.77-2-14.67s-1.23-9.8-1.73-14.71Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.9,173.92c3.33,1,7.34,12.48,7.34,12.48l-12.93,9.24s-4.71-9.57-3.31-13.88C357.45,177.28,361.1,172.76,364.9,173.92Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.5,204.4A19.57,19.57,0,0,0,300,228.56l-.87,7.18,7.19-.86h0A19.57,19.57,0,0,0,330.5,204.4ZM310.89,224a8.16,8.16,0,1,1,11.54,0A8.15,8.15,0,0,1,310.89,224Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.5,204.4A19.57,19.57,0,0,0,300,228.56l-.87,7.18,7.19-.86h0A19.57,19.57,0,0,0,330.5,204.4ZM310.89,224a8.16,8.16,0,1,1,11.54,0A8.15,8.15,0,0,1,310.89,224Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.39 218.42 332.33 225.34 338.94 226.41 338.27 218.11 331.39 218.42",
    style: {
      fill: "#ffb573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Globe--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.53,400.89h0a112.2,112.2,0,0,1-79.34-191.54,1,1,0,0,1,1.41,0l11.88,11.87a1,1,0,0,1-1.42,1.42L134.9,211.48A110.2,110.2,0,0,0,290.74,367.32l-11.18-11.18a1,1,0,1,1,1.42-1.42l11.89,11.89a1,1,0,0,1,0,1.42A111.49,111.49,0,0,1,213.53,400.89Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.53,
    cy: 288.69,
    r: 95.44,
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-37)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.89,210.45l8.56,1.64c-.75.57-1.27,1.45-2.05,2,6.12.07,12.59-.63,18.49,1,5.51,1.54,10.24-.43,15.87.17,3.3.36,39.73,2.81,38.68,7.75-2.57-.4-5.93-1.68-8.35-.27l4.34,1.86c-2.3,1.27-8.5,2.35-8.47,4.54,0,1.57,2.16,2.27,2.74,3.67s.32,3.62.45,5.09c-1.79-1.62-6.67-4.51-7.35-6.68s3.29-6.19-2.54-5.33c-2.13.31-1.91,2.22-2.46,2.43-1.36.53-3.89.14-5.37.19-4.91.17-4.58,1.1-6.76,5.34,2.95.53,6.81.49,8.74,2.43s3.42,8.36,1.26,10.33c-1.06,1-2.58.22-3.25.75s-1.86,3.34-1.64,4.11c.62,2.17,7.42,4.6,1.34,6.2-.77-1.27-2.47-5.76-3.81-6.29-1.89-.75-4.14,2.22-4.2-1.7L328.39,252a5.4,5.4,0,0,0,5.45,1.81c-3.85,1-1.22,4-.06,5.37,1.79,2.1,1.89,2.16,2,4.51.21,4.32-2.75,7.78-7.19,8.76-2.23.49-3.85-.25-5.29,1.32-2.19,2.37-.06,2.56,1.17,4.53.86,1.39,2.61,4.19,2.32,5.87-.25,1.43-3,3.19-4.19,4.31-1.51-2.21-2.64-5.15-5.56-5.86-.26,3.65-.59,5.05,2,7.88.8.87,1.79,1.31,2.34,2.25s.41,2.93,1,4.16c-7.64-4.1-6.45-11.92-9.07-19.17-1.74,4.44-3.43-1.63-4.19-3-1.72-3-3.51-4-6.9-2-1.64.95-6.06,5.15-6.71,6.87-1.5,3.94,1.23,5.53-2,9-2.42-1.71-3-5.46-3.9-8-1-2.78-2.77-5.87-2.5-8.9-1.78,3.81-4.3-.91-5.94-2.3-2.42-2-4-1.12-7.23-1.42a20.34,20.34,0,0,1-3.69-1.06c.63.17-1.44-1.22-1.15-1.1-.43-.19-1.11.63-1.71.4-1.89-.74-5.42-4.56-7.09-3.61.72,1.42,2.15,5.48,3.61,6.29,2.27,1.26,4-1.31,5.75-1a14.27,14.27,0,0,1,3.5,3.36c.3,1.31,0,.84-1,2.55a11.11,11.11,0,0,1-5.27,5c-1.77,1-5.88,3.6-8,3.65-2.76.06-2.71-1.12-3.89-3.34s-6.63-15.65-9.29-14.13c2.08,4.5,3.85,9.35,6.42,13.62.92,1.53,3.53,6.51,5.2,7.19,2,.81,5.82-1,7.57-1.53-.85,8-7.42,11-11.26,17.16-3.48,5.54,2.85,12-1.34,16.86-1.12,1.31-4.23,1.92-5,3.41-.64,1.23.58,3.11.2,4.48-.5,1.79-1.58,1.14-2.68,2.72-.9,1.28-.61,3.12-1.64,4.58a11.36,11.36,0,0,1-7.56,5.24c-4.79,1.08-5.2.93-6.77-3.26L224,322.61c-1.22-3.25-.71-4.54.27-8s1.34-4.25-.11-7.39a50.56,50.56,0,0,1-2.83-6.07c-.53-1.78,0-3.1-.23-4.95-.2-1.46-.14-2.25-1.5-3.44-.37-.33-1.65.35-2.11.11s-.89-1.7-1.46-1.81c-2.39-.45-5.67,1.15-8.43,1.26-4.2.16-7,.09-9.76-2.49s-5.17-5.51-5.39-9.39c-.48-8.48,5.83-11.58,9.33-18.42,1.16-2.27,0-3.1,2.95-4.84,1.49-.89,1.9-.81,3.77-1.16,4.44-.83,9.11-1,13.6-1.54-.39,3.38-.67,2.87,2.08,4.53,2.19,1.32,4.73,2.29,7,3.41.77-4.81,7.21-1.3,10.75-1,5.42.48,4.47-2.1,5.38-6.63-2.12.11-4.91.74-6.93.07-3-1-2.54-2.27-3-5.06l-3.34.61a5.2,5.2,0,0,1,.23,4.38,26.8,26.8,0,0,1-3.13-3.38c-.44-.72-.48-2.12-.88-2.65-1.44-1.91-4.19-3.48-6.06-5-2.24,3.19,3,5.67,5.28,6.9-2.17,2.56-2.78,5.12-5.89,2.36,3.5.22,3.89-.68,2.17-3.09-1.83-2.58-4.25-4-6.85-3.85-.4,0-.71,1.09-1.11,1.13s-1.62-.81-2-.62-1.07-.24-1.41-.09.17,1.37,0,1.53c-1.53,1.36-2.65,3.44-4,4.83-1.79,1.87-3.71,3.55-6.45,2-2-1.17-2.74-5.15-1.42-7.24,1.61-2.55,5.16.63,7.47-1.09s-.79-4.36-2-5.69a39,39,0,0,0,5.53-2.11c2-1.15,1.43-2.06,3.06-3.26,1.26-.94,2.11-.36,2.93-1.43,1.21-1.57-1.44-3.23,2.11-3.39-1.94,5,6.81,4.38,9.34,2.59.54-.38.07-1.65.45-2.19a12.18,12.18,0,0,1,1.56-1.31v-1.33h1.7c1.14-.84,1.92.69,2.48-1.37-2.46.42-3.87,1.32-5.44-.28-2.22-2.26-.32-2.8,1.65-4.38-3.61-2.58-8.92,4.72-4.5,5.37-.83,1-3.06,5.05-4.29,5.31-2.45.53-2-2.88-2.33-4.54-1.64.65-2.75,1.46-3.86.76-1.28-.8-1.24-2.94-.87-3.6.76-1.35,4.24-1.81,5.56-2.86s2-3.22,3.52-4.19c5.07-3.32,15.1-2.1,19.73,1.45-2.11,1.28-4.74.44-7.06.17,1.36,1.8,3.26,4,5.73,3.23.31-.1.89-1.68,1.47-2.05,1.33-.87,3.62-1.27,5.14-1.81,5.09-1.79,9-1.83,14.36-.85-2.61-7,1.61-3,6.46-3.87,2.32-.41,4.45-2.24,6.69-2.95A67.21,67.21,0,0,1,286.89,210.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.45,237.72,206.61,239c.64-.94,2.38-2.61,2.48-3.65.2-2.21-1-1.06-1.36-1.88-1.66-3.42-.76-3.53,2.33-5.25.42,1.69.54,4.07,1.39,5.64S214.86,236.16,212.45,237.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.17,233.64c-1.7,2.92-.31,2.89-4.28,3.53C203.91,234.81,203.33,232.13,207.17,233.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.68,216.47c-6.91-2.09,3.93-5.13,5.29-5.47-2.82,0-6.75-.57-9,1.64C251.5,215.09,254.43,217.85,257.68,216.47Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.86,211l2.5-2a12.67,12.67,0,0,0-7-.77Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.25,207.49c1.84,2,4.34,1,6.79.69C231.77,207.86,229.54,207.64,227.25,207.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M343,258.37a12.67,12.67,0,0,0,2.17,3.17c1-4.35,3.72-2.13,6.57-4.77,1.54-1.42,1.43-4.42-.62-6.45-2.88-2.87-.58,1.55-1.73,3.58C348.11,256.1,344.65,256.2,343,258.37Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M348.8,249l.89-.33c-.14-.33-.29-.66-.44-1,1.64.6,3.28.59,3.78-1.2l-5.45-2.25C349.1,246.31,346.76,247.43,348.8,249Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M347.19,243.42h1.39a69.43,69.43,0,0,0-6.9-9.2C340.79,236.27,345.85,241.36,347.19,243.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M337.9,268.44c-1.59.71-1.52,2.31-.41,3.65Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M325.85,274.79h1.7c-.52,1.59-.3,1.38-1.93,1.57Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M312.27,291.48c5.87,2.47,11.61,7.7,11.61,13.91-3.05-.24-5.25-4.14-6.51-6.42S312.88,293.65,312.27,291.48Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M329.61,296.7l-1.72-.38c-1.67,4.61,3.74,9,7.29,5.58,1.64-1.58,1.3-4.51,1.64-6.38.48-2.61,1.48-3.51-1.09-5.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M335.56,289.25c1.25-1.51,3-2.89,3-4.93C337.57,286,336.56,287.61,335.56,289.25Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M339.85,283.45c-2-2.79-1.87-3.7-1.62-7.09,2.43.28,1.2,3.68,2.67,5.41,2.12,2.49,4.71,2.47,4.88,6.45.1,2.4-1.22,4.51-3.9,1.92C340.11,288.43,341.29,285.59,339.85,283.45Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M344.63,296.75c-2.34,1.24-4.6-.68-6.06,2.09,2-1.46,3.57-.82,5.78-.41A7.47,7.47,0,0,0,344.63,296.75Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M342.41,299.16c-2.28,1.65-3.49-.54-4.41,2.48-.37,1.21.23,3.79,1.57,3.75-.05-1.44-.58-3,.58-3.93-.29,1.74.32,2.84,2.26,2.14l-1.62-3c.74.08,1.54-.31,2.28-.22Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M333.17,307.87c-2.21-.58-7.48-3.11-9.29-1.48C326.16,307.4,331.29,310,333.17,307.87Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M348.08,295.44a3.54,3.54,0,0,0-.56,4.33A5.64,5.64,0,0,0,348.08,295.44Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M347.66,302c.27,1.31,1.7,1,3.2,1.15C350.56,301.72,349.21,301.66,347.66,302Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M346.13,302l.61.58a1.6,1.6,0,0,1-1.16,0Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M351.08,299.77c0,3,2.9,3.91,5,4.86s4.52,1.91,1.22,4.06c1.59-.23,2.95.82,4.2.71a13.75,13.75,0,0,0,2,0c.52-.12.79-1.86,1.31-1.87,1.53,0,1.33.57,2.69,1.55a9.87,9.87,0,0,0,4.29,2.19c-1.85-2.24-3.89-5.84-6.15-7.56-1-.76-5.24-2.7-6.6-2.73-1.62,0-2.1.62-3.66,1.8C354.78,300.77,353.86,298,351.08,299.77Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M368.83,304.69c1.76,1.31,7,.91,5.34-1.91C372.65,304.91,371.32,304.69,368.83,304.69Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M351.81,311.81c-.75.94-2.54,4.2-3.62,4.55-1.68.53-2.33-1.09-3.64-.85-2.87.54-5.93,5.61-8.42,7.07-4.32,2.52-6.61,1.83-7.23,7.41-.22,2.05.84,4.43.36,6.43-.44,1.85-3,2.69.3,3.72,3.13,1,9.45-2.6,12.76-3.22,1.78-.34,2.58-1,4.35,0,1.42.83,1.47,2.38,2.43,3.78,5.91,8.65,16,.06,19.45-6.27,2.33-4.24,1.18-7.69-1.43-11.48-1.12-1.62-1.77-2-2.51-3.83-.92-2.28-1.23-5-1.83-7.35l-3.93,8c-3.71-2.75-5-2.51-2.81-6.5Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M353.22,346.64l4.67.29c-1.37,1.8-2.25,4.28-5,3.51Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M370.65,352.78c3.58,1.89,3.62,1.22,7-1,1.82-1.2,6.52-2.72,4-5.16Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M382.59,346.64a8.64,8.64,0,0,0,1.19,1.46c1-.8,5.28-3.26,5.44-4.37s-2.39-3.3-3.22-4.32Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M399.15,318.88a9.74,9.74,0,0,0-1.67.93C399,320.93,400.82,320.8,399.15,318.88Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M382.29,322.82s4.66,3.58,4.29,2.47C386.11,323.9,383.67,322.72,382.29,322.82Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M334.52,308.31c.64,2.31,8.67.52,11.06,0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M338.57,310.06c.5,1.12,3.17,2.33,3.89.88Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M263.13,313.13c-2.28,2.06-5.15,3.78-5.83,6.69-.36,1.52-1.46,7.88-.12,8.86,3.1,2.28,4.14-4.77,4.74-6.43C263.27,318.48,264,317,263.13,313.13Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56,220.67c2.3.62,3.4-.1,5.48-1C204.9,218.66,197.59,218.21,200.56,220.67Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.73,292.1c-1.93,3.2-3.74,5.78-4.4,9.38-.88,4.8.39,6,2.93,10.33a20.13,20.13,0,0,0,2.57,4.19c1.48,1.51,4,2.06,5.55,3.56,2.34,2.34,1.8,4.46,2,8,.48,7.53.17,15.09,2.65,22.28,1.25,3.63,1.94,6.64,4.44,9.51,3.58,4.12,4.89,4.24,10.28,4.24-4.39-3.47-6.22-4-6.32-9.28-.1-4.86-.51-6.26,2.49-10,5.64-7,13.45-14,16.46-22.35q1.48-4.11,2.95-8.22c.57-1.58,3.15-5.93,2.73-7.6-.59-2.33-8.51-4.08-11.32-5.14-1.19-.46-3.73-.92-4.58-1.83-1.6-1.7-1.06-5.14-2.56-6.93-2-2.41-10.12-5.2-13.28-6.12-2.27-.66-3.1-.56-5.7-.19-2.29.32-4.81,1.52-6.79,1.79a18.11,18.11,0,0,1-5-.69c-2.84-1.48-1.51-4.44-1.11-6.75l-5.57-.65,3-7c-2.35.67-2.91,1.61-4.6,2.48-1.1.56-3.43,1.89-4.78,1.19-3-1.56-2.48-8-.7-10.34,1.5-2,7.06-3.41,9.93-3.7,5.7-.57,5.47,2,7.05,6.42,2.14-2.71-.29-5.55,1-8.1,1.07-2.06,5.4-3.41,7.13-5.17,4.89-4.94,6.8-8.9,13.71-11.33v1.46l5.93-2.34h-4.23a6.65,6.65,0,0,1,1.27-3.21l-4.45.66c3.74-2,9.49-1.27,12.67-3.29,3.38-2.15-.83-7.47-2.07-10.15l-4.08,2.41c-1.53-2.19,1.31-2.77-2.26-4.11-3-1.11-3.45,0-5.06,1.84s-6,10.53-8.7,10.52c.79-3.32,1.77-3.72-.85-5.18-1.72-1-7.46-.54-6.63-4,.57-2.37,10.59-6.3,13.12-7.74-.46.84-.56,1.85-1,2.7l4.83-.07-3-2.63c3.77-.47,4.45-.2,6.31-3.36-2.46-.48-4.13,1-6.08,2.19.52-2.7-2.5-1.78-4.48-1.81l-13.62-.21c-3.53,0-7.15-.34-10.67-.16-2.63.14-5.3,1.14-7.91,1.12-6.61,0-11.12-2.85-17.73-1.31-7,1.62-11,4.83-16.87,8.87.71.83,1.43,1.66,2.15,2.48l-5,3.51c5.21-1.75,12.42-5.74,17.84-5.47,3.15.16,6.51,1.12,7.3,3.44s.25,6.43-.42,8.68c-1.52,5.12-9.09,12.81-5.51,18.61.46.75,2,.84,2.5,1.64.85,1.35.11,4.3.48,5.87.46,2,2,6.19,4.59,6.07-1.69-3.82-2.83-6.5-3.19-10.58,3,.83,5.92,8,6.47,10.46.24,1.08-.26,2.6.17,3.46.58,1.16,4.74,3.46,5.86,3.93,1.56.65,3.6,0,5.08.69,1.1.49,2.9,2.53,4,3.31.82.57,1.85.45,2.58,1.09s1,2.1,1.71,2.89c1.27,1.36,3.43,2.2,5.11,3.15C138,285.36,140.25,290.94,140.73,292.1Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M134.54,272c4.07-1.57,6.47,3.18,10.53,2.41C140.71,272.15,139.14,270.25,134.54,272Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146,274.94c2,.21,4.76-.3,5.34,1.83-2.41.43-4.44,1.13-6.67-.22.75,0,1.55-.3,2.3-.33Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M140.62,276.22a20.12,20.12,0,0,1,2.15.47,8.44,8.44,0,0,1-2.15.81Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.41,276.22a1.88,1.88,0,0,0,2.3.64C154,276.65,153.19,276.39,152.41,276.22Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M171.77,237.83l-3.72,3.56L174.5,243c-.09-.93.12-2.77-.34-3.62C173.61,238.32,171.56,240.33,171.77,237.83Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M168.05,219.67l-6.37,2.84c1.85.66,6,3.07,7.87,2.78s4.9-3.66,6.45-4.82c-2-1.87-4.81-5.66-7.39-6.57a11.29,11.29,0,0,0-10.34,2c.7.59,1.72,1.91,2.6,2.19.61.2,1.68-.92,2.32-.81C165,217.59,167.45,217.8,168.05,219.67Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M165.91,218.79c-2.84.82-1.12,1.7.82.62Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M153.23,218.79c-4.35-3,4.56-6.28,7.12-6.28-1.31.76-4.23,1.81-4.9,3C154.58,217.12,156.7,219.77,153.23,218.79Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M134.69,218.79c0-1.2,1.7-3.22,2.29-4.31-1.73.46-4.28,2.08-5,0,3.14-1.06,4.84-1.9,7.94-1.32,3.62.68,4.67,1.37,8.37.74-.67,1.7-1.51,3.06-1,4.89Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M139.73,211.27c4.51,2.14,7,1.48,12,.91-1.7-.38-4-1.66-5.57-1.86C144.28,210.08,141.64,211,139.73,211.27Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M152.64,213.1a16.42,16.42,0,0,0-2.9.8,6.24,6.24,0,0,0,1.19,1.75l4.15-2.55A22.07,22.07,0,0,0,152.64,213.1Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M154.19,211.42c1.94,1.26,7.61.67,9.94.84,3.21.24,3.84,0,6.72-1.43,5.29-2.66,10.66-3.54,16.5-4.82-6.07,0-12.63-.71-18.64,0C165.45,206.4,154.4,207.57,154.19,211.42Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M177.8,210.85c5.21-1.61,9.52-2.87,15-3.23a72.26,72.26,0,0,1,16,.65c-2.47,2.51-5.23,6.62-8.41,8.14-2.3,1.1-5.45.62-7.75,1.72-1.78.86-3.4,2.87-4.89,4.15-3.76,3.27-5.55-.37-4.9-4.25.26-1.6,2.26-4.37.48-6C182.06,211,179.22,212.06,177.8,210.85Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M213.53,414.31a1,1,0,0,1-1-1V399.89a1,1,0,0,1,2,0v13.42A1,1,0,0,1,213.53,414.31Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.19,413.31c0,1.62-12.83,2.93-28.66,2.93s-28.67-1.31-28.67-2.93,12.84-5.66,28.67-5.66S242.19,411.69,242.19,413.31Z",
    style: {
      fill: "#B0BEC5"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.47578c71734389da906f499800b9dd11.svg";
export { ForwardRef as ReactComponent };